<template>
    <Icon v-if="Icon" class="ui-icon" />
    <slot v-else class="ui-icon" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { iconRegistry } from './iconRegistry'

const props = defineProps<{
  size?: number | string
  icon?: string
  strokeWidth?: number | string
}>()

/**
 * Normaliza a largura dos traços do icone
 */
const iconStrokeWidth = computed(() => props.strokeWidth ?? 1.5)

/**
 * Normaliza o tamanho da fonte (inherit caso omisso)
 */
const iconSize = computed(() => {
  if (!props.size) return '1.5em'
  const size = `${props.size}`.toLowerCase().replace(/\s*/, '').match(/(\d+)(px|em|rem|%)?/)
  return `${size[1] || 14}${size[2] || 'px'}`
})

const Icon = computed(() => {
  if (!props.icon) return null

  const icon = iconRegistry[props.icon]

  if (!icon && import.meta.env.DEV) {
    console.warn(`[UiIcon] Ícone "${props.icon}" não encontrado no iconRegistry. Rode "npm run icons:sync".`)
  }

  return icon
})
</script>

<style lang="scss" scoped>
.ui-icon {
  height: v-bind(iconSize);
  width: v-bind(iconSize);
  stroke-width: v-bind(iconStrokeWidth);
  vertical-align: middle;
}
</style>
